/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
ceregoCommon.controller("goodForNowModal", ['$scope', 'DebugHelper', ($scope, DebugHelper) => DebugHelper.register("goodForNowModal", $scope)
]);
